import request from '../../util/request'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
import { config } from '../../config/config'

export default class FlowFromApi {
  /**
   * 根据 FID 获取表单解析json数据 /  流程表单管理信息  / 流程信息 / 流程配置信息
   * @param id
   */
  static getFlowFormInfoByFid(fId) {
    if (formUtils.isNull(fId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/formflow/getInfoByFid?fid=' + fId,
      method: 'get',
    })
  }

  static getFlowFormConfigByFid(fId) {
    if (formUtils.isNull(fId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/process/getInitFormConfig?fid=' + fId,
      method: 'get',
    })
  }

  static getDraftJson(draftId) {
    if (formUtils.isNull(draftId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/draft/detail?id=' + draftId,
      method: 'get',
    })
  }

  /**
   * 根据 FFID 获取表单解析json数据 /  流程表单管理信息  / 流程信息 / 流程配置信息
   * @param id
   */
  static getFlowFormInfoByFFid(ffId) {
    if (formUtils.isNull(ffId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/process/getActFormInfo?ffId=' + ffId,
      method: 'get',
    })
  }

  /**
   * 根据 FFID 获取表单解析json数据 /  流程表单管理信息  / 流程信息 / 流程配置信息
   * @param id
   */
  static getFormNoFlowInfo(ffId, dataType) {
    if (formUtils.isNull(ffId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    let url = '/v1/table/formDetail?ffid='
    if (dataType === 'supply') {
      url = '/v1/supplement/info?ffid='
    }
    return request({
      url: config.baseAPI + url + ffId,
      method: 'get',
    })
  }

  /**
   * 根据 FFID ,taskId 获取表单解析json数据 /  流程表单管理信息  / 流程信息 / 流程配置信息
   * @param id
   */
  static getFlowFormInfoConfigByFFid(ffId, taskId) {
    if (formUtils.isNull(ffId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    // if (formUtils.isNull(taskId)) {
    //   alertUtils.alertWarning('接口参数不能为空', true)
    //   return
    // }
    return request({
      url:
        config.baseAPI +
        '/v1/process/getFormElementConfig?ffid=' +
        ffId +
        '&taskId=' +
        taskId,
      method: 'get',
    })
  }

  static getNoFlowFormInfoConfigByFFid(ffId) {
    if (formUtils.isNull(ffId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    // if (formUtils.isNull(taskId)) {
    //   alertUtils.alertWarning('接口参数不能为空', true)
    //   return
    // }
    return request({
      url: config.baseAPI + '/v1/table/formDetail?ffid=' + ffId,
      method: 'get',
    })
  }

  /**
   * 根据 FID 获取表单生成  HTML 信息
   * @param id
   */
  static getHTMLByFid(fId) {
    if (formUtils.isNull(fId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/formflow/getHtmlByFid?fid=' + fId,
      method: 'get',
    })
  }

  /**
   * 根据保存表单输入信息
   * @param data
   */
  static saveFlowFormInfo(data) {
    return request({
      url: config.baseAPI + '/v1/process/saveActForm',
      method: 'post',
      data,
    })
  }

  /**
   * 根据保存表单输入信息提交到下一个节点
   * @param data
   */
  static submitFlowFormInfo(data) {
    request({
      url: config.baseAPI + '/v1/process/commitActForm',
      method: 'post',
      data,
    }).then(() => {})
  }

  /**
   * 根据保存表单输入信息
   * @param data
   */
  static agreeFlowFormInfo(data) {
    request({
      url: config.baseAPI + '/v1/process/completeActForm',
      method: 'post',
      data,
    }).then(() => {})
  }

  /**
   * 获取事件js
   * @param taskId
   */
  static getFreeJs(taskId) {
    if (formUtils.isNull(taskId)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/process/getButtonConfig?taskId=' + taskId,
      method: 'get',
    })
  }

  /**
   * 获取事件js
   * @param taskId
   */
  static getWriteFreeJs(defId) {
    return request({
      url: config.baseAPI + '/v1/actModel/getBpmnByDeployId?defId=' + defId,
      method: 'get',
    })
  }
}
